/*
 * @Description: 备案合同待办历史 配置
 * @Date: 2026-09-18
 */

import { ref } from 'vue'
import dayjs from 'dayjs'
import { enumToOption } from '@/utils'

// 创建时间始默认值：当前时间七天之前
export const getDefaultCreateTimeStart = () =>
  dayjs()
    .subtract(7, 'day')
    .format('YYYY-MM-DD HH:mm:ss')

// 待办类型：1-新增备案 2-作废备案 3-调整合同 4-申请转移 5-转移结果同步
export enum jobTypeEnum {
  新增备案 = 1,
  作废备案,
  调整合同,
  申请转移,
  转移结果同步
}

export const jobTypeOption = enumToOption(jobTypeEnum)

// 搜索配置
export const inputList = (remoteData1: any) => [
  {
    type: 'select',
    label: '企业名称',
    key: 'companyUuid',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 340,
    maxlength: 50,
    options: remoteData1.options,
    isLoading: remoteData1.isLoading,
    isRemote: true,
    isMultiple: false,
    isFilterable: true,
    isCollapseTags: false,
    remoteMethod: remoteData1.remoteMethod,
    rules: {
    }
  },
  {
    type: 'select-remote-pagination',
    label: '关联资产',
    key: 'settingId',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 200,
    requestUrl: '/enterpriseViolationSetting/query',
    requestKey: 'orgName',
    labelKey: 'orgName',
    valueKey: 'id',
    remote: true
  },
  {
    type: 'input',
    label: '子合同编号',
    key: 'contractSubNo',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 200
  },
  {
    type: 'input',
    label: '源合同编号',
    key: 'contractNo',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 200
  },
  {
    type: 'select',
    label: '待办类型',
    key: 'jobType',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 200,
    options: jobTypeOption,
    rules: {
      type: 'number'
    }
  },
  {
    type: 'datePicker',
    dateType: 'datetime',
    label: '创建时间始',
    key: 'createTimeStart',
    placeholder: '请选择',
    value: getDefaultCreateTimeStart(),
    format: 'YYYY-MM-DD HH:mm:ss',
    itemShow: true,
    labelWidth: 100,
    inputWidth: 200,
    isArea: true
  },
  {
    type: 'datePicker',
    dateType: 'datetime',
    label: '创建时间止',
    key: 'createTimeEnd',
    placeholder: '请选择',
    format: 'YYYY-MM-DD HH:mm:ss',
    itemShow: true,
    labelWidth: 100,
    inputWidth: 200,
    isArea: true
  }
]

// 页面搜索和基础变量
export const getIndexConfig = () => {
  // 页面基础变量
  const page = {
    queryForm: ref<any>({}), // 搜索参数
    visible: false,
    rowData: null,
    determine: false,
    title: ''
  }
  return {
    ...page
  }
}

// 表格配置
export const getTableConfig = () => {
  // table 通用属性
  const common = {
    // table 有多选时设置
    isSelection: false,
    // table loading
    loading: false,
    // table 的高度
    height: null,
    // table 是否为斑马纹
    stripe: true,
    // table 的高度
    size: 'small',
    // table 是否开启索引
    isIndex: false,
    // table 索引 label
    indexLabel: '序号',
    // table 数据
    data: []
  }

  // table 分页
  const pagination = {
    // 是否展示分页
    isShow: true,
    // 总条数
    total: 0,
    // 每页显示条目个数
    pageSize: 20,
    // 当前页数
    currentPage: 1,
    // 每页显示个数选择器的选项设置
    pageSizes: [10, 20, 40, 80, 100]
  }

  // table 列数据
  const column = [
    {
      key: 'companyName',
      label: '企业名称',
      width: '160',
      formatter: (row: any) => row.companyName || '-'
    },
    {
      key: 'orgName',
      label: '资产名称',
      width: '160',
      formatter: (row: any) => row.orgName || '-'
    },
    {
      key: 'contractNo',
      label: '源合同编号',
      width: '180',
      formatter: (row: any) => row.contractNo || '-'
    },
    {
      key: 'contractSubNo',
      label: '子合同编号',
      width: '180',
      formatter: (row: any) => row.contractSubNo || '-'
    },
    {
      key: 'jobType',
      label: '待办类型',
      width: '120',
      formatter: (row: any) => jobTypeEnum[row.jobType] || '-'
    },
    {
      key: 'createTime',
      label: '创建时间',
      width: '160',
      formatter: (row: any) => row.createTime || '-'
    },
    {
      key: 'lastTime',
      label: '上一次操作时间',
      width: '160',
      formatter: (row: any) => row.lastTime || '-'
    },
    {
      key: 'retryCount',
      label: '重试次数',
      width: '100',
      formatter: (row: any) =>
        row.retryCount === null || row.retryCount === undefined
          ? '-'
          : row.retryCount
    },
    {
      key: 'finishTime',
      label: '完结时间',
      width: '160',
      formatter: (row: any) => row.finishTime || '-'
    },
    {
      key: 'finishReason',
      label: '完结原因',
      width: '160',
      formatter: (row: any) => row.finishReason || '-'
    }
  ]

  return {
    ...common,
    pagination,
    column
  }
}
